export default [
  {
    path: '/app/guides',
    name: 'Guides',
    component: () => import('@/views/Guides/Index.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'pages.guides',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
      resource: 'GUIDES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/guides/add',
    name: 'GuidesAdd',
    component: () => import('@/views/Guides/Add.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'pages.guides',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/tasks?tab=guides',
          active: false,
        },
        {
          text: 'breadcrumb.create',
          active: true,
        },
      ],
      resource: 'GUIDES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/guides/edit/:id',
    name: 'GuidesEdit',
    component: () => import('@/views/Guides/Edit.vue'),
    meta: {
      navActiveLink: 'Tasks',
      pageTitle: 'pages.guides',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/tasks?tab=guides',
          active: false,
        },
        {
          text: 'breadcrumb.update',
          active: true,
        },
      ],
      resource: 'GUIDES_EDIT',
      action: 'read',
    },
  },
]
